//大型商品用リードタイムを設定する。大型商品は地域に関わらず以下の設定で固定。
window.CustomDeliveryDatetime.settings.LARGE_SIZE_LEAD_TIMES = {
	LARGE:{WEEKDAYS:8,HOLIDAYS:9},//超大型商品
	LARGE_SHIPPING:{WEEKDAYS:10,HOLIDAYS:11},//超大型配送
	LARGE_DELIVERY:{WEEKDAYS:10,HOLIDAYS:11},//超大型配達
};